import React from 'react';
import styled from 'styled-components';
import Cover from './cover';
import Content from './content';

const Wrapper = styled.div``;

const Page = ({ knowledge = {} }) => {
  React.useEffect(() => {
    document.title = knowledge.websiteTitle;
  }, [knowledge]);

  return (
    <Wrapper>
      <Cover knowledge={knowledge} />
      <Content knowledge={knowledge} />
    </Wrapper>
  );
};

export default Page;
